import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import StudyListTableRow from './StudyListTableRow';
import { apiUrl } from '../UploadDocument/apiUrl';

const StudyListTable = ({ tableDataSource, querying, dataSource }) => {
  const [isActive, setIsActive] = useState(false);

  const fetchState = async () => {
    try {
      const response = await fetch(apiUrl + '/api/dicom/findActivate');
      const data = await response.json();
      if (data && data.isActive !== undefined) {
        setIsActive(data.isActive); // Actualiza el estado del botón con el valor de isActive
      }
    } catch (error) {
      console.error('Error al obtener el estado:', error);
    }
  };
  useEffect(() => {
    fetchState(); // Obtener el estado actual del backend cuando se monta el componente
  }, []);
  return (
    <div className="bg-black">
      <div className="container relative m-auto">
        <div className="w-full text-white">
          <div
            data-cy="study-list-results"
            data-querying={querying}
          >
            {tableDataSource.map((tableData, i) => {
              return (
                <StudyListTableRow
                  tableData={tableData}
                  dataSource={dataSource}
                  active={isActive}
                  key={i}
                />
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

StudyListTable.propTypes = {
  seriesTableColumnsTable: PropTypes.object || PropTypes.array,
  seriesInStudiesMapTable: PropTypes.object || PropTypes.array,
  tableDataSource: PropTypes.arrayOf(
    PropTypes.shape({
      row: PropTypes.array.isRequired,
      TableContent: PropTypes.any,
      querying: PropTypes.bool,
      onClickRow: PropTypes.func,
      isTable: PropTypes.bool,
    })
  ),
  querying: PropTypes.bool,
  dataSource: PropTypes.object,
};

export default StudyListTable;
